import React, { memo, useEffect, useState } from "react";
import { Col, Row } from "reactstrap";
import "./MarketProfile.css";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Clear from "@mui/icons-material/Clear";
import { Table, TableBody, TableCell, TableRow } from "@mui/material";
import StarBorderIcon from "@mui/icons-material/StarBorder";
import DownloadOutlinedIcon from "@mui/icons-material/DownloadOutlined";
import FmdGoodOutlinedIcon from "@mui/icons-material/FmdGoodOutlined";
import moment from "moment";
import { Config } from "../../../Utils/Config";
import StarIcon from "@mui/icons-material/Star";
import { handlingCatchError } from "../../../Utils/ErrorHandling";

import { useNavigate, useLocation} from "react-router-dom";
import { ExportProfile } from "./ExportProfile";
import { ExportProfile_Layout } from "./ExportProfile_Layout";
import Snackbar from "@mui/material/Snackbar";
import axios from "axios";
import FacilityTypes from '../../../Assets/Images/icons/Facility Types.png';
import PhoneNumber from '../../../Assets/Images/icons/Phone Number.webp';
import OwnershipType from '../../../Assets/Images/icons/Ownership Type.webp';
import Fax from '../../../Assets/Images/icons/Fax.png';
import Email from '../../../Assets/Images/icons/Email.png';
import Facebook from '../../../Assets/Images/icons/Facebook.webp';
import Instagram from '../../../Assets/Images/icons/Instagram.webp';
import GoogleRating from '../../../Assets/Images/icons/Google Rating.png';
import LandSize from '../../../Assets/Images/icons/Land Size.png';
import YearOpened from '../../../Assets/Images/icons/Year Opened.png';
import Tollfree from '../../../Assets/Images/icons/Toll free.png';
import Acreage from '../../../Assets/Images/icons/Acreage.png';
import Website from '../../../Assets/Images/icons/Website.png';
import ProfileName from '../../../Assets/Images/icons/Profile Name.png';
import Address from '../../../Assets/Images/icons/Address.png';
import Seasonality from '../../../Assets/Images/icons/Seasonality.png';
import OnlineBookingStatus from '../../../Assets/Images/icons/Online Booking Status.png';
import Hookups2 from '../../../Assets/Images/icons/Hookups2.png';
import ShowerandBathrooms2 from '../../../Assets/Images/icons/Shower and Bathrooms2.png';
import DumpStation2 from '../../../Assets/Images/icons/Dump Station2.png';
import BackIn2 from '../../../Assets/Images/icons/BackIn2.png';
import DogParks2 from '../../../Assets/Images/icons/DogParks2.png';
import LaundryAccess2 from '../../../Assets/Images/icons/LaundryAccess2.png';
import PullInPullThrough2 from '../../../Assets/Images/icons/PullInPullThrough2.png';
import SelfServiceCarWash2 from '../../../Assets/Images/icons/SelfServiceCarWash2.png';
import OnsitePropane2 from '../../../Assets/Images/icons/Onsite Propane2.png';
import TentCamping2 from '../../../Assets/Images/icons/Tent Camping2.png';
import SiteLockers2 from '../../../Assets/Images/icons/Site Lockers2.png';
import InternetConnectivity2 from '../../../Assets/Images/icons/Internet Connectivity2.png';
import InternetConnectivityPayment2 from '../../../Assets/Images/icons/Internet Connectivity Payment2.png';
import CellphoneConnectivity2 from '../../../Assets/Images/icons/Cellphone Connectivity2.png';
import Lakeside2 from '../../../Assets/Images/icons/Lake-side2.png';
import SwimmingPool2 from '../../../Assets/Images/icons/Swimming Pool2.png';
import Fishing2 from '../../../Assets/Images/icons/Fishing2.png';
import RecHall2 from '../../../Assets/Images/icons/Rec Hall2.webp';
import Cabins2 from '../../../Assets/Images/icons/Cabins2.png';
import Cafe2 from '../../../Assets/Images/icons/Cafe2.webp';
import SportsCourts2 from '../../../Assets/Images/icons/Sports Courts2.png';
import PetAllowed2 from '../../../Assets/Images/icons/Pet Allowed2.png';
import GolfcartRentals2 from '../../../Assets/Images/icons/Golfcart Rentals2.png';
import BeachAccess2 from '../../../Assets/Images/icons/Beach Access2.png';
import AttractionsDescriptions2 from '../../../Assets/Images/icons/Attractions Descriptions2.png';
import GameRoomArcade2 from '../../../Assets/Images/icons/GameRoom Arcade2.png';
import RVSiteDailyPerNight from '../../../Assets/Images/icons/RV Site Daily Per Night.png';
import RvsiteMonthly from '../../../Assets/Images/icons/Rvsite Monthly.png';
import RvsiteWeekly from '../../../Assets/Images/icons/Rvsite Weekly.png';
import Discount from '../../../Assets/Images/icons/Discount.png';
import Form from '../../../Assets/Images/icons/Form.png';
import BookingEngineName from '../../../Assets/Images/icons/Booking Engine Name.webp';
import CheckIn from '../../../Assets/Images/icons/Check In.png';
import CheckOut from '../../../Assets/Images/icons/Check Out.png';
import Average from '../../../Assets/Images/icons/Average.png';
import PicnicTable2 from '../../../Assets/Images/icons/Picnic Table2.webp';
import FireRing2 from '../../../Assets/Images/icons/Fire Ring2.png';
import VehicularAccess2 from '../../../Assets/Images/icons/Vehicular Access2.png';
import ElectricHookup2 from '../../../Assets/Images/icons/Electric Hookup2.png';
import WaterHookup2 from '../../../Assets/Images/icons/Water Hookup2.png';
import SewerHookup2 from '../../../Assets/Images/icons/Sewer Hookup2.png';
import AdditionalLodging2 from '../../../Assets/Images/icons/Additional Lodging2.png';
import NoofSpots from '../../../Assets/Images/icons/No of Spots.png';
import LoanAmount from '../../../Assets/Images/icons/Loan Amount.png';
import LoanType from '../../../Assets/Images/icons/Loan Type.png';
import InterestType from '../../../Assets/Images/icons/Interest Type.png';
import City from '../../../Assets/Images/icons/City.png';
import State from '../../../Assets/Images/icons/State.png';
import Country from '../../../Assets/Images/icons/Country.png';
import Title from '../../../Assets/Images/icons/Title.png';
import Hiking from '../../../Assets/Images/icons/Hiking.png';
import BoatingRentals from '../../../Assets/Images/icons/Boating Rentals.png';
import Kayaking from '../../../Assets/Images/icons/Kayaking.png';
import Canoeing from '../../../Assets/Images/icons/Canoeing.png';
import Others from '../../../Assets/Images/icons/others.png';
import glamping from '../../../Assets/Images/icons/glamping2.png';
import evCharging from '../../../Assets/Images/icons/Vehicle Charging2.png';
import { formatSeasonalityText, isValidUrl, validateUrlElement } from "../../../helpers/dataHelper";
import { apiCommonTriggerBlob , apiCommonTrigger } from "../../../Utils/apiServicehelper";

let list = [];
let eList = [];

const MarketProfile = memo((props) => {
   
  let id =
    props && (props !== undefined || props !== null) && props.id !== null
      ? props.id
      : null;
  const [expanded, setExpanded] = useState("panel1");
  const [isFavProfile, setFavProfile] = useState(null);
  const [downloadPDF, setDownloadPDF] = useState(false);
  const profileData = props.profileData.profileInfo;
  const profileId =
    profileData && profileData !== undefined
      ? profileData.profile && profileData.profile.profileid
      : null;
  const cLat =
    profileData && profileData !== undefined
      ? profileData.geodetail && profileData.geodetail.latitude
      : null;
  const cLng =
    profileData && profileData !== undefined
      ? profileData.geodetail && profileData.geodetail.longitude
      : null;
  const navigate = useNavigate();
  const location = useLocation();
  const [snack, setSnackOpen] = useState({ snackOpen: false, snackMsg: "" });
  const apiPath = process.env.REACT_APP_API_URL;
  // expand collapse Accordion
  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  function sortObject(obj) {
    if (obj && obj !== null) {
      return Object.keys(obj)
        .sort()
        .reduce(function (result, key) {
          result[key] = obj[key];

          return result;
        }, {});
    }
  }
  function sortActivity(obj){
  const entries = Object.keys(obj.activitylist);
const array =[]
const data = obj.keys
  for (let i = 0; i < Object.keys(data).length; i++) {
  if(entries.find((l => l ===Object.values(data)[i]))){
   if(Object.values(data)[i] === 'Others'){
   array.push({[Object.values(data)[i]]:obj.activitylist.Others})
   }
   else{
   array.push({[Object.values(data)[i]]:'Yes'})
   }
}
else{ 
  Object.values(data)[i]==='Others' ?
  array.push({[Object.values(data)[i]]:'-'})
  :
 array.push({[Object.values(data)[i]]:'No'})
}
 }
var object = array.reduce(function(result, current) {
  var key = Object.keys(current)[0];
  var value = current[key];
  result[key] = value;
  return result;
}, {});
return object;
  }

  const isfavoriteCurrentProfile = () => {
    let addr = "";
    const latitude =
      profileData && profileData !== undefined
        ? profileData.geodetail && profileData.geodetail.latitude
        : null;
    const longitude =
      profileData && profileData !== undefined
        ? profileData.geodetail && profileData.geodetail.longitude
        : null;
    const profileId =
      profileData && profileData !== undefined
        ? profileData.profile && profileData.profile.profileid
        : null;
    const profileName =
      profileData && profileData !== undefined
        ? profileData.profile && profileData.profile.profilename
        : null;
    const street =
      profileData &&
      profileData !== undefined &&
      profileData.profile &&
      profileData.profile.streetaddress1
        ? profileData.profile.streetaddress1+", "
       : "";
    const city =
      profileData &&
      profileData !== undefined &&
      profileData.profile &&
      profileData.profile.city
        ? ", " + profileData.profile.city + ", "
        : "";
    const stateCode =
      profileData &&
      profileData !== undefined &&
      profileData.profile &&
      profileData.profile.statecode
        ? profileData.profile.statecode + " "
        : "";
    const zipCode =
      profileData &&
      profileData !== undefined &&
      profileData.profile &&
      profileData.profile.zipcode
        ? profileData.profile.zipcode
        : "";

    if (profileName && profileName !== null) {
      addr = profileName;
    }

    if (street && street !== null) {
      // when addr is empty,append just like tat
      if (addr === "") {
        addr = street;
      }
      // when addr is not empty & no comma exists, include comma
      if (addr !== "" && !street.startsWith(",")) {
        addr = addr + "," + street;
      }
      // when addr is not empty &  comma exists, dont include comma
      if (addr !== "" && street.startsWith(",")) {
        addr = addr + street;
      }
    }
    if (city && city !== null) {
      if (addr === "") {
        addr = city;
      }

      if (addr !== "" && !city.startsWith(",")) {
        addr = addr + "," + city;
      }
      if (addr !== "" && city.startsWith(",")) {
        addr = addr + city;
      }
    }
    if (stateCode && stateCode !== null) {
      if (addr === "") {
        addr = stateCode;
      }

      if (addr !== "" && !city.startsWith(",")) {
        addr = addr + "," + stateCode;
      }
      if (addr !== "" && city.startsWith(",")) {
        addr = addr + stateCode;
      }
    }
    if (zipCode && zipCode !== null) {
      if (addr === "") {
        addr = zipCode;
      }

      if (addr !== "" && !zipCode.endsWith(",")) {
        addr = addr + ", " + zipCode;
      }
      if (addr !== "" && zipCode.endsWith(",")) {
        addr = addr + +" " + zipCode;
      }
    }
    const address = addr;
apiCommonTrigger("post",`${Config.API_URL}/maps/address/isfavorite`, {
                  latitude,
        longitude,
        profileId,
        address,
            }).then((res) => {
      if (res.status === 200) {
        setFavProfile(res.data.id);
        if(!props?.isDemoMarket){
          props.callMarketCenter(cLat, cLng , false);
        }
      } else{
        handlingCatchError(res, navigate);
      }
    })
    .catch(err => {
      handlingCatchError(err, navigate);
    })
  };

  useEffect(() => {
    if (location.pathname !== "/preview-market" && location.pathname !== "/market-data" && location.pathname !== "/") {
      isfavoriteCurrentProfile();
    }
   
  }, [profileData]);
  const favoriteCurrentProfile = () => {
     
    let latitude,
      longitude,
      profileId,
      address,
      profileName,
      street,
      city,
      stateCode,
      zipCode;
    const obj =
      props && (props !== undefined || props !== null) && props.id !== null
        ? props
        : null;
    const id =
      props && (props !== undefined || props !== null) && props.id !== null
        ? props.id
        : 0;
    if (id !== 0 && id !== undefined && obj !== null && obj.latitude !== null && obj.longitude !== null) {
      latitude = obj && obj.latitude !== null ? obj.latitude : null;
      longitude = obj && obj.longitude !== null ? obj.longitude : null;
      profileId = obj && obj.profileId !== null ? obj.profileId : null;
      address = obj && obj.address !== null ? obj.address : null;
    } else {
      let addr = "";

      latitude =
        profileData && profileData !== undefined
          ? profileData.geodetail && profileData.geodetail.latitude
          : null;
      longitude =
        profileData && profileData !== undefined
          ? profileData.geodetail && profileData.geodetail.longitude
          : null;
      profileId =
        profileData && profileData !== undefined
          ? profileData.profile && profileData.profile.profileid
          : null;
      profileName =
        profileData && profileData !== undefined
          ? profileData.profile && profileData.profile.profilename
          : null;
      street =
        profileData &&
        profileData !== undefined &&
        profileData.profile &&
        profileData.profile.streetaddress1
          ? profileData.profile.streetaddress1
          : props.address
          ? props.address
          : "";
      city =
        profileData &&
        profileData !== undefined &&
        profileData.profile &&
        profileData.profile.city
          ? ", " + profileData.profile.city + ", "
          : "";
      stateCode =
        profileData &&
        profileData !== undefined &&
        profileData.profile &&
        profileData.profile.statecode
          ? profileData.profile.statecode + " "
          : "";
      zipCode =
        profileData &&
        profileData !== undefined &&
        profileData.profile &&
        profileData.profile.zipcode
          ? profileData.profile.zipcode
          : "";
      if (profileName && profileName !== null) {
        addr = profileName;
      }

      if (street && street !== null) {
        // when addr is empty,append just like tat
        if (addr === "") {
          addr = street;
        }
        // when addr is not empty & no comma exists, include comma
        if (addr !== "" && !street.startsWith(",")) {
          addr = addr + "," + street;
        }
        // when addr is not empty &  comma exists, dont include comma
        if (addr !== "" && street.startsWith(",")) {
          addr = addr + street;
        }
      }
      if (city && city !== null) {
        if (addr === "") {
          addr = city;
        }

        if (addr !== "" && !city.startsWith(",")) {
          addr = addr + "," + city;
        }
        if (addr !== "" && city.startsWith(",")) {
          addr = addr + city;
        }
      }
      if (stateCode && stateCode !== null) {
        if (addr === "") {
          addr = stateCode;
        }

        if (addr !== "" && !city.startsWith(",")) {
          addr = addr + "," + stateCode;
        }
        if (addr !== "" && city.startsWith(",")) {
          addr = addr + stateCode;
        }
      }
      if (zipCode && zipCode !== null) {
        if (addr === "") {
          addr = zipCode;
        }

        if (addr !== "" && !zipCode.endsWith(",")) {
          addr = addr + ", " + zipCode;
        }
        if (addr !== "" && zipCode.endsWith(",")) {
          addr = addr + " " + zipCode;
        }
      }
      address = addr;
    }
    apiCommonTrigger("post",`${Config.API_URL}/maps/address/favorite`, {
               id,
        latitude,
        longitude,
        profileId,
        address,
            }).then((res) => {
      if (res.status === 200) {
        setFavProfile(res.data.id);
      }else{
        handlingCatchError(res, navigate);
      }
    })
    .catch(err => {
      handlingCatchError(err, navigate);
    })
  };

  //price conversion
  const priceConversion = (tot) => {
    if (tot === null || tot === undefined)
      return null;

    if (tot !== "") {
      let checkDigit = tot.toString().split(".");
      let ret = "";
      let i = 0;
      if (tot.toString().indexOf(".") == -1) {
        tot = tot;
      } else {
        if (checkDigit == "00") {
          tot = checkDigit.trim();
        } else {
          if (checkDigit.length === 2) {
            ret += checkDigit[0] + ".";
            for (i = 0; i < checkDigit.length; i++) {
              if (i >= checkDigit[1].length) ret += "0";
              else ret += checkDigit[1][i];
            }
          } else if (checkDigit.length === 1) {
            ret += checkDigit[0] + ".";
            for (i = 0; i < checkDigit.length; i++) {
              ret += "0";
            }
          }
          ret = ret.toString();
          tot = ret;
        }
      }
    }
    return tot.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };

  const handleDeleteFavorite = () => {
    apiCommonTrigger("delete" , Config.API_URL + "/maps/address/favorite/" , [isFavProfile])
    .then((res) => {
      if (res.status === 200) {
        setFavProfile(null);
        return;
      }
      else{
        handlingCatchError(res, navigate);
      }
    })
    .catch(err => {
      handlingCatchError(err, navigate);
    })
  };

  //get store details
  const storelistProp = (infoDetails, isFrom) => {
    list = [];
    eList = [];
    let data = infoDetails;
    let step = 0;
    let count;
    if (isFrom === "marketing" || isFrom === "ownership" || isFrom === "debt") {
      if (data.length > 0) {
        for (let overAllIndex = 0; overAllIndex < data.length; overAllIndex++) {
          let indexResult = data[overAllIndex];
          step = 0;
          for (let i = 0; i < Object.keys(indexResult).length; i++) {
            if (
              Object.values(indexResult)[i] !== null &&
              Object.values(indexResult)[i] !== undefined &&
              Object.values(indexResult)[i] !== "" &&
              Object.values(indexResult)[i] !== 0 &&
              Object.values(indexResult)[i] !== "0" &&
              Object.keys(indexResult)[i] !== "rvprofileid" && 
              Object.keys(indexResult)[i] !== "profileid" 
            ) {
              step = step + 1;
              count = overAllIndex + 1;
              let tableHeader =
                Object.keys(indexResult)[i] === "loanamount"
                  ? <><div className="img-text"><span className="img-tag"><img src={LoanAmount} alt='icons' className='table-icons'/></span><span className="pro-name">Loan Amount</span></div></>
                  : Object.keys(indexResult)[i] === "loanmaturitydate"
                  ? <><div className="img-text"><span className="img-tag"><img src={YearOpened} alt='icons' className='table-icons'/></span><span className="pro-name">Loan Maturity Date</span></div></>
                  : Object.keys(indexResult)[i] === "loanoriginationdate"
                  ? <><div className="img-text"><span className="img-tag"><img src={YearOpened} alt='icons' className='table-icons'/></span><span className="pro-name">Loan Origination Date</span></div></>
                  : Object.keys(indexResult)[i] === "loantype"
                  ? <><div className="img-text"><span className="img-tag"><img src={LoanType} alt='icons' className='table-icons'/></span><span className="pro-name">Loan Type</span></div></>
                  : Object.keys(indexResult)[i] === "interestrate"
                  ? <><div className="img-text"><span className="img-tag"><img src={LoanAmount} alt='icons' className='table-icons'/></span><span className="pro-name">Interest Rate</span></div></>
                  : Object.keys(indexResult)[i] === "interesttype"
                  ? <><div className="img-text"><span className="img-tag"><img src={InterestType} alt='icons' className='table-icons'/></span><span className="pro-name">Interest Type</span></div></>
                  : Object.keys(indexResult)[i] === "loanduration"
                  ? <><div className="img-text"><span className="img-tag"><img src={YearOpened} alt='icons' className='table-icons'/></span><span className="pro-name">Loan Duration</span></div></>
                  : Object.keys(indexResult)[i] === "landvalue"
                  ? <><div className="img-text"><span className="img-tag"><img src={LoanAmount} alt='icons' className='table-icons'/></span><span className="pro-name">Land Value</span></div></>
                  : Object.keys(indexResult)[i] === "improvementvalue"
                  ? <><div className="img-text"><span className="img-tag"><img src={LoanAmount} alt='icons' className='table-icons'/></span><span className="pro-name">Improvement Value</span></div></>
                  : Object.keys(indexResult)[i] === "marketvalue"
                  ? <><div className="img-text"><span className="img-tag"><img src={LoanAmount} alt='icons' className='table-icons'/></span><span className="pro-name">Market Value</span></div></>
                  : Object.keys(indexResult)[i] === "totalmarketvalue"
                  ? <><div className="img-text"><span className="img-tag"><img src={LoanAmount} alt='icons' className='table-icons'/></span><span className="pro-name">Total Market Value</span></div></>
                  : Object.keys(indexResult)[i] === "lastsaledate"
                  ? <><div className="img-text"><span className="img-tag"><img src={YearOpened} alt='icons' className='table-icons'/></span><span className="pro-name">Last Sale Date</span></div></>
                  : Object.keys(indexResult)[i] === "lastsalevalue"
                  ? <><div className="img-text"><span className="img-tag"><img src={LoanAmount} alt='icons' className='table-icons'/></span><span className="pro-name">Last Sale Value</span></div></>
                  : Object.keys(indexResult)[i] === "companyphone"
                  ? <><div className="img-text"><span className="img-tag"><img src={PhoneNumber} alt='icons' className='table-icons'/></span><span className="pro-name">Company Phone</span></div></>
                  : Object.keys(indexResult)[i] === "companyemail"
                  ? <><div className="img-text"><span className="img-tag"><img src={Email} alt='icons' className='table-icons' style={{height: '12px', marginTop: '1px'}}/></span><span className="pro-name">Company Email</span></div></>
                  : Object.keys(indexResult)[i] === "companyname"
                  ? <><div className="img-text"><span className="img-tag"><img src={ProfileName} alt='icons' className='table-icons'/></span><span className="pro-name">Company Name</span></div></>
                  : Object.keys(indexResult)[i] === "streetaddress1"|| Object.keys(indexResult)[i] === "ownerstreetaddress1"
                  ? <><div className="img-text"><span className="img-tag"><img src={Address} alt='icons' className='table-icons'/></span><span className="pro-name">Address Line1</span></div></>
                  : Object.keys(indexResult)[i] === "streetaddress2" || Object.keys(indexResult)[i] === "ownerstreetaddress2" 
                  ? <><div className="img-text"><span className="img-tag"><img src={Address} alt='icons' className='table-icons'/></span><span className="pro-name">Address Line2</span></div></>
                  : Object.keys(indexResult)[i] === "city"
                  ? <><div className="img-text"><span className="img-tag"><img src={City} alt='icons' className='table-icons'/></span><span className="pro-name">City</span></div></>
                  : Object.keys(indexResult)[i] === "state"
                  ? <><div className="img-text"><span className="img-tag"><img src={State} alt='icons' className='table-icons'/></span><span className="pro-name">State</span></div></>
                  : Object.keys(indexResult)[i] === "country"
                  ? <><div className="img-text"><span className="img-tag"><img src={Country} alt='icons' className='table-icons'/></span><span className="pro-name">Country</span></div></>
                  : (Object.keys(indexResult)[i] === "zipcode" || Object.keys(indexResult)[i] === "zipCode" ||Object.keys(indexResult)[i] === "ownerzipcode")
                  ? <><div className="img-text"><span className="img-tag"><img src={Address} alt='icons' className='table-icons'/></span><span className="pro-name">ZipCode</span></div></>
                  : Object.keys(indexResult)[i] === "fax" ||  Object.keys(indexResult)[i] === "ownerfax"
                  ? <><div className="img-text"><span className="img-tag"><img src={Fax} alt='icons' className='table-icons'/></span><span className="pro-name">Fax</span></div></>
                  : Object.keys(indexResult)[i] === "tollfree" || Object.keys(indexResult)[i] === "ownertollfree"
                  ? <><div className="img-text"><span className="img-tag"><img src={Tollfree} alt='icons' className='table-icons'/></span><span className="pro-name">Toll-free</span></div></>
                  : Object.keys(indexResult)[i] === "website" || Object.keys(indexResult)[i] === "ownerwebsite"
                  ? <><div className="img-text"><span className="img-tag"><img src={Website} alt='icons' className='table-icons'/></span><span className="pro-name">Website</span></div></>
                  : Object.keys(indexResult)[i] === "firstname" ||  Object.keys(indexResult)[i] === "ownerfirstname"
                  ? <><div className="img-text"><span className="img-tag"><img src={ProfileName} alt='icons' className='table-icons'/></span><span className="pro-name">First Name</span></div></>
                  : Object.keys(indexResult)[i] === "lastname" ||  Object.keys(indexResult)[i] === "ownerlastname"
                  ? <><div className="img-text"><span className="img-tag"><img src={ProfileName} alt='icons' className='table-icons'/></span><span className="pro-name">Last Name</span></div></>
                  : Object.keys(indexResult)[i] === "title"
                  ? <><div className="img-text"><span className="img-tag"><img src={Title} alt='icons' className='table-icons'/></span><span className="pro-name">Title</span></div></>
                  : Object.keys(indexResult)[i] === "ownerphone"
                  ? <><div className="img-text"><span className="img-tag"><img src={PhoneNumber} alt='icons' className='table-icons'/></span><span className="pro-name">Owner Phone</span></div></>
                  : Object.keys(indexResult)[i] === "owneremail"
                  ? <><div className="img-text"><span className="img-tag"><img src={Email} alt='icons' className='table-icons' style={{height: '12px', marginTop: '1px'}}/></span><span className="pro-name">Owner Email</span></div></>
                  : Object.keys(indexResult)[i] === "valueyear"
                  ? <><div className="img-text"><span className="img-tag"><img src={YearOpened} alt='icons' className='table-icons' style={{height: '12px', marginTop: '1px'}}/></span><span className="pro-name">Value Year</span></div></>
                  : Object.keys(indexResult)[i] === "ownerstate"
                  ? <><div className="img-text"><span className="img-tag"><img src={State} alt='icons' className='table-icons' style={{height: '12px', marginTop: '1px'}}/></span><span className="pro-name">Owner State</span></div></> :

                  Object.keys(indexResult)[i] === "ownercity"
                  ? <><div className="img-text"><span className="img-tag"><img src={City} alt='icons' className='table-icons' style={{height: '12px', marginTop: '1px'}}/></span><span className="pro-name">Owner City</span></div></> :

                  Object.keys(indexResult)[i] === "ownercompanyemail"
                  ? <><div className="img-text"><span className="img-tag"><img src={Email} alt='icons' className='table-icons' style={{height: '12px', marginTop: '1px'}}/></span><span className="pro-name">Owner Email</span></div></> :
                  
                  Object.keys(indexResult)[i] === "ownercountry"
                  ? <><div className="img-text"><span className="img-tag"><img src={Country} alt='icons' className='table-icons' style={{height: '12px', marginTop: '1px'}}/></span><span className="pro-name">Owner Country</span></div></> :

                  Object.keys(indexResult)[i] === "ownertitle"
                  ? <><div className="img-text"><span className="img-tag"><img src={Title} alt='icons' className='table-icons' style={{height: '12px', marginTop: '1px'}}/></span><span className="pro-name">Owner Title</span></div></> :
                  
                  Object.keys(indexResult)[i] === "ownercompanyphone"
                  ? <><div className="img-text"><span className="img-tag"><img src={PhoneNumber} alt='icons' className='table-icons' style={{height: '12px', marginTop: '1px'}}/></span><span className="pro-name">Owner Company Phone</span></div></> : Object.keys(indexResult)[i] ;


              let tableRowValue =
                Object.keys(indexResult)[i] === "loanmaturitydate" ||
                Object.keys(indexResult)[i] === "lastsaledate" ||
                Object.keys(indexResult)[i] === "loanoriginationdate"
                  ? moment(Object.values(indexResult)[i]).format("DD-MMM-YYYY")
                  : Object.keys(indexResult)[i] === "loanamount" ||
                    Object.keys(indexResult)[i] === "lastsalevalue" ||
                    Object.keys(indexResult)[i] === "landvalue" ||
                    Object.keys(indexResult)[i] === "improvementvalue" ||
                    Object.keys(indexResult)[i] === "marketvalue" ||
                    Object.keys(indexResult)[i] === "totalmarketvalue"
                  ? Config.Currency +
                    priceConversion(Object.values(indexResult)[i])
                  : Object.keys(indexResult)[i] === "interestrate"
                  ? Object.values(indexResult)[i] + "%"
                  : Object.keys(indexResult)[i] === "loanduration"
                  ? Object.values(indexResult)[i] + " months"
                  : Object.values(indexResult)[i];
              list.push(
                <TableRow
                  key={Object.keys}
                  className={data.length > 1 ? "three-col-table" : ""}
                >
                  {step === 1 && data.length > 1 ? (
                    <TableCell>{count + ")"}</TableCell>
                  ) : (
                    <TableCell className="hide-td"></TableCell>
                  )}
                  <TableCell>{tableHeader}</TableCell>
                  <TableCell>{tableRowValue}</TableCell>
                </TableRow>
              );
            }
          }
        }
      }
    } else {
      if (data !== null) {
        for (let i = 0; i < Object.keys(data).length; i++) {
          if (
            Object.values(data)[i] !== null &&
            Object.values(data)[i] !== undefined &&
            Object.values(data)[i] !== "" &&
            Object.keys(data)[i] !== "id" &&
            Object.keys(data)[i] !== "rvProfileId"
          ) {
            let url, sourceURL;
            if (Object.keys(data)[i] === "website" || Object.keys(data)[i] === "ownerwebsite") {
              sourceURL = "http://" + Object.values(data)[i].toString().replace(/&amp;/gi, "&");
              const isValid = isValidUrl(sourceURL);
              url = isValid ? new URL(sourceURL) : null;
              
            }
            let tableHeader =
              Object.keys(data)[i] === "facilitytypes"
                ? <><div className="img-text"><span className="img-tag"><img src={FacilityTypes} alt='icons' className='table-icons'/></span><span className="pro-name">Facility Types</span></div></>
                :  Object.keys(data)[i] === "phone"
                ? <><div className="img-text"><span className="img-tag"><img src={PhoneNumber} alt='icons' className='table-icons'/></span><span className="pro-name">Phone Number</span></div></>
                :  Object.keys(data)[i] === "fax"
                ? <><div className="img-text"><span className="img-tag"><img src={Fax} alt='icons' className='table-icons'/></span><span className="pro-name">Fax</span></div></>
                :  Object.keys(data)[i] === "email"
                ? <><div className="img-text"><span className="img-tag"><img src={Email} alt='icons' className='table-icons' style={{height: '12px', marginTop: '1px'}}/></span><span className="pro-name">Email Address</span></div></>
                :  Object.keys(data)[i] === "facebook"
                ? <><div className="img-text"><span className="img-tag"><img src={Facebook} alt='icons' className='table-icons'/></span><span className="pro-name">Facebook</span></div></> 
                :  Object.keys(data)[i] === "instagram"
                ? <><div className="img-text"><span className="img-tag"><img src={Instagram} alt='icons' className='table-icons'/></span><span className="pro-name">Instagram</span></div></>
                :  Object.keys(data)[i] === "rating"
                ? <><div className="img-text"><span className="img-tag"><img src={GoogleRating} alt='icons' className='table-icons'/></span><span className="pro-name">Google Rating</span></div></>
                :  Object.keys(data)[i] === "landsize"
                ? <><div className="img-text"><span className="img-tag"><img src={LandSize} alt='icons' className='table-icons'/></span><span className="pro-name">Land Size</span></div></>          
                : Object.keys(data)[i] === "yearopened"
                ? <><div className="img-text"><span className="img-tag"><img src={YearOpened} alt='icons' className='table-icons'/></span><span className="pro-name">Year Opened</span></div></>
                : Object.keys(data)[i] === "tollfree"
                ? <><div className="img-text"><span className="img-tag"><img src={Tollfree} alt='icons' className='table-icons'/></span><span className="pro-name">Toll-free</span></div></>
                : Object.keys(data)[i] === "aceragefields"
                ? <><div className="img-text"><span className="img-tag"><img src={Acreage} alt='icons' className='table-icons'/></span><span className="pro-name">Acreage</span></div></>
                : Object.keys(data)[i] === "website"
                ? <><div className="img-text"><span className="img-tag"><img src={Website} alt='icons' className='table-icons'/></span><span className="pro-name">Website</span></div></>
                : Object.keys(data)[i] === "ownershiptype"
                ? <><div className="img-text"><span className="img-tag"><img src={OwnershipType} alt='icons' className='table-icons'/></span><span className="pro-name">Ownership Type</span></div></>
                : Object.keys(data)[i] === "profilename"
                ? <><div className="img-text"><span className="img-tag"><img src={ProfileName} alt='icons' className='table-icons'/></span><span className="pro-name">Profile Name</span></div></>
                : Object.keys(data)[i] === "streetaddress1"
                ? <><div className="img-text"><span className="img-tag"><img src={Address} alt='icons' className='table-icons'/></span><span className="pro-name">Address</span></div></>
                
                : Object.keys(data)[i] === "streetaddress2"
                ? <><div className="img-text"><span className="img-tag"><img src={Address} alt='icons' className='table-icons'/></span><span className="pro-name">Address2</span></div></>
                : Object.keys(data)[i] === "seasonalityname"
                ? <><div className="img-text"><span className="img-tag"><img src={Seasonality} alt='icons' className='table-icons'/></span><span className="pro-name">Seasonality</span></div></>
                : Object.keys(data)[i] === "onlinebookingstatus"
                ? <><div className="img-text"><span className="img-tag"><img src={OnlineBookingStatus} alt='icons' className='table-icons'/></span><span className="pro-name">Online Booking Status</span></div></>
                : Object.keys(data)[i] === "hookups"
                ? <><div className="img-text"><span className="img-tag"><img src={Hookups2} alt='icons' className='table-icons'/></span><span className="pro-name">Hookups</span></div></>
                : Object.keys(data)[i] === "showersandbathrooms"
                ? <><div className="img-text"><span className="img-tag"><img src={ShowerandBathrooms2} alt='icons' className='table-icons'/></span><span className="pro-name">Shower and Bathrooms</span></div></>
                : Object.keys(data)[i] === "dumpstation"
                ? <><div className="img-text"><span className="img-tag"><img src={DumpStation2} alt='icons' className='table-icons'/></span><span className="pro-name">Dump Station</span></div></>
                : Object.keys(data)[i] === "selfservicecarwash"
                ? <><div className="img-text"><span className="img-tag"><img src={SelfServiceCarWash2} alt='icons' className='table-icons'/></span><span className="pro-name">Self Service Car Wash</span></div></>
                : Object.keys(data)[i] === "pullinpullthrough"
                ? <><div className="img-text"><span className="img-tag"><img src={PullInPullThrough2} alt='icons' className='table-icons' style={{height: '16px'}}/></span><span className="pro-name">Pull In Pull Through</span></div></>
                : Object.keys(data)[i] === "laundryaccess"
                ? <><div className="img-text"><span className="img-tag"><img src={LaundryAccess2} alt='icons' className='table-icons'/></span><span className="pro-name">Laundry Access</span></div></>
                : Object.keys(data)[i] === "dogparks"
                ? <><div className="img-text"><span className="img-tag"><img src={DogParks2} alt='icons' className='table-icons'/></span><span className="pro-name">Dog Parks</span></div></>
                : Object.keys(data)[i] === "backin"
                ? <><div className="img-text"><span className="img-tag"><img src={BackIn2} alt='icons' className='table-icons'/></span><span className="pro-name">Back In</span></div></>
                : Object.keys(data)[i] === "onsitepropane"
                ? <><div className="img-text"><span className="img-tag"><img src={OnsitePropane2} alt='icons' className='table-icons'/></span><span className="pro-name">Onsite Propane</span></div></>
                : Object.keys(data)[i] === "tentcamping"
                ? <><div className="img-text"><span className="img-tag"><img src={TentCamping2} alt='icons' className='table-icons'/></span><span className="pro-name">Tent Camping</span></div></>
                : Object.keys(data)[i] === "sitelockers"
                ? <><div className="img-text"><span className="img-tag"><img src={SiteLockers2} alt='icons' className='table-icons'/></span><span className="pro-name">Site Lockers</span></div></>
                : Object.keys(data)[i] === "internetconnectivity"
                ? <><div className="img-text"><span className="img-tag"><img src={InternetConnectivity2} alt='icons' className='table-icons'/></span><span className="pro-name">Internet Connectivity</span></div></>
                : Object.keys(data)[i] === "internetconnectivitypayment"
                ? <><div className="img-text"><span className="img-tag"><img src={InternetConnectivityPayment2} alt='icons' className='table-icons'/></span><span className="pro-name">Internet Connectivity Payment</span></div></>
                : Object.keys(data)[i] === "cellphoneconnectivity"
                ? <><div className="img-text"><span className="img-tag"><img src={CellphoneConnectivity2} alt='icons' className='table-icons'/></span><span className="pro-name">Cellphone Connectivity</span></div></>
                : Object.keys(data)[i] === "lakeside"
                ? <><div className="img-text"><span className="img-tag"><img src={Lakeside2} alt='icons' className='table-icons'/></span><span className="pro-name">Lake-side</span></div></>
                : Object.keys(data)[i] === "swimmingpool"
                ? <><div className="img-text"><span className="img-tag"><img src={SwimmingPool2} alt='icons' className='table-icons'/></span><span className="pro-name">Swimming Pool</span></div></>
                : Object.keys(data)[i] === "fishing"
                ? <><div className="img-text"><span className="img-tag"><img src={Fishing2} alt='icons' className='table-icons'/></span><span className="pro-name">Fishing</span></div></>
                : Object.keys(data)[i] === "rechall"
                ? <><div className="img-text"><span className="img-tag"><img src={RecHall2} alt='icons' className='table-icons'/></span><span className="pro-name">Rec Hall</span></div></>
                : Object.keys(data)[i] === "cabins"
                ? <><div className="img-text"><span className="img-tag"><img src={Cabins2} alt='icons' className='table-icons'/></span><span className="pro-name">Cabins</span></div></>
                : Object.keys(data)[i] === "cafe"
                ? <><div className="img-text"><span className="img-tag"><img src={Cafe2} alt='icons' className='table-icons'/></span><span className="pro-name">Cafe</span></div></>
                : Object.keys(data)[i] === "sportscourts"
                ? <><div className="img-text"><span className="img-tag"><img src={SportsCourts2} alt='icons' className='table-icons'/></span><span className="pro-name">Sports Courts</span></div></>
                : Object.keys(data)[i] === "petallowed"
                ? <><div className="img-text"><span className="img-tag"><img src={PetAllowed2} alt='icons' className='table-icons'/></span><span className="pro-name">Pet Allowed</span></div></>
                : Object.keys(data)[i] === "golfcartrentals"
                ? <><div className="img-text"><span className="img-tag"><img src={GolfcartRentals2} alt='icons' className='table-icons'/></span><span className="pro-name">Golfcart Rentals</span></div></>
                : Object.keys(data)[i] === "beachaccess"
                ? <><div className="img-text"><span className="img-tag"><img src={BeachAccess2} alt='icons' className='table-icons'/></span><span className="pro-name">Beach Access</span></div></>
                : Object.keys(data)[i] === "attractionsdescriptions"
                ? <><div className="img-text"><span className="img-tag"><img src={AttractionsDescriptions2} alt='icons' className='table-icons'/></span><span className="pro-name">Attractions Descriptions</span></div></>
                : Object.keys(data)[i] === "gameroomarcade"
                ? <><div className="img-text"><span className="img-tag"><img src={GameRoomArcade2} alt='icons' className='table-icons'/></span><span className="pro-name">GameRoom Arcade</span></div></>
                : Object.keys(data)[i] === "rvsitedailypernight"
                ? <><div className="img-text"><span className="img-tag"><img src={RVSiteDailyPerNight} alt='icons' className='table-icons'/></span><span className="pro-name">RV Site Daily Per Night</span></div></>
                : Object.keys(data)[i] === "rvsiteweekly"
                ? <><div className="img-text"><span className="img-tag"><img src={RvsiteWeekly} alt='icons' className='table-icons'/></span><span className="pro-name">Rvsite Weekly</span></div></>
                : Object.keys(data)[i] === "rvsitemonthly"
                ? <><div className="img-text"><span className="img-tag"><img src={RvsiteMonthly} alt='icons' className='table-icons'/></span><span className="pro-name">Rvsite Monthly</span></div></>
                : Object.keys(data)[i] === "tentsitedailypernight"
                ? <><div className="img-text"><span className="img-tag"><img src={RVSiteDailyPerNight} alt='icons' className='table-icons'/></span><span className="pro-name">Tent Site Daily</span></div></>
                : Object.keys(data)[i] === "tentsiteweekly"
                ? <><div className="img-text"><span className="img-tag"><img src={RvsiteWeekly} alt='icons' className='table-icons'/></span><span className="pro-name">Tent Site Weekly</span></div></>
                : Object.keys(data)[i] === "tentsitemonthly"
                ? <><div className="img-text"><span className="img-tag"><img src={RvsiteMonthly} alt='icons' className='table-icons'/></span><span className="pro-name">Tent Site Monthly</span></div></>
                : Object.keys(data)[i] === "cabindailypernight"
                ? <><div className="img-text"><span className="img-tag"><img src={RVSiteDailyPerNight} alt='icons' className='table-icons'/></span><span className="pro-name">Cabin Daily Per Night</span></div></>
                : Object.keys(data)[i] === "cabinweekly"
                ? <><div className="img-text"><span className="img-tag"><img src={RvsiteWeekly} alt='icons' className='table-icons'/></span><span className="pro-name">Cabin Weekly</span></div></>
                : Object.keys(data)[i] === "cabinweekly"
                ? <><div className="img-text"><span className="img-tag"><img src={RvsiteMonthly} alt='icons' className='table-icons'/></span><span className="pro-name">Cabin Monthly</span></div></>
                : Object.keys(data)[i] === "discountclubs"
                ? <><div className="img-text"><span className="img-tag"><img src={Discount} alt='icons' className='table-icons'/></span><span className="pro-name">Discount Clubs</span></div></>
                : Object.keys(data)[i] === "discountdetail"
                ? <><div className="img-text"><span className="img-tag"><img src={Discount} alt='icons' className='table-icons'/></span><span className="pro-name">Discount Detail</span></div></>
                : Object.keys(data)[i] === "bookingenginename"
                ? <><div className="img-text"><span className="img-tag"><img src={BookingEngineName} alt='icons' className='table-icons'/></span><span className="pro-name">Booking Engine Name</span></div></>
                : Object.keys(data)[i] === "bookingengineurl"
                ? <><div className="img-text"><span className="img-tag"><img src={Website} alt='icons' className='table-icons'/></span><span className="pro-name">Booking Engine Url</span></div></>
                : Object.keys(data)[i] === "bookingform"
                ? <><div className="img-text"><span className="img-tag"><img src={Form} alt='icons' className='table-icons'/></span><span className="pro-name">Booking Form</span></div></>
                : Object.keys(data)[i] === "bookingphone"
                ? <><div className="img-text"><span className="img-tag"><img src={PhoneNumber} alt='icons' className='table-icons'/></span><span className="pro-name">Booking Phone</span></div></>
                : Object.keys(data)[i] === "bookingemail"
                ? <><div className="img-text"><span className="img-tag"><img src={Email} alt='icons' className='table-icons' style={{height: '12px', marginTop: '1px'}}/></span><span className="pro-name">Booking Email</span></div></>
                : Object.keys(data)[i] === "checkin"
                ? <><div className="img-text"><span className="img-tag"><img src={CheckIn} alt='icons' className='table-icons'/></span><span className="pro-name">Check In</span></div></>
                : Object.keys(data)[i] === "checkout"
                ? <><div className="img-text"><span className="img-tag"><img src={CheckOut} alt='icons' className='table-icons'/></span><span className="pro-name">Check Out</span></div></>
                : Object.keys(data)[i] === "sourceurl"
                ? <><div className="img-text"><span className="img-tag"><img src={Website} alt='icons' className='table-icons'/></span><span className="pro-name">Source Url</span></div></>
                : Object.keys(data)[i] === "avgrvdailypernight"
                ? <><div className="img-text"><span className="img-tag"><img src={Average} alt='icons' className='table-icons'/></span><span className="pro-name">Avg RV Daily Per Night</span></div></>
                : Object.keys(data)[i] === "picnictable"
                ? <><div className="img-text"><span className="img-tag"><img src={PicnicTable2} alt='icons' className='table-icons'/></span><span className="pro-name">Picnic Table</span></div></>
                : Object.keys(data)[i] === "firering"
                ? <><div className="img-text"><span className="img-tag"><img src={FireRing2} alt='icons' className='table-icons'/></span><span className="pro-name">Fire Ring</span></div></>
                : Object.keys(data)[i] === "vehicularaccess"
                ? <><div className="img-text"><span className="img-tag"><img src={VehicularAccess2} alt='icons' className='table-icons'/></span><span className="pro-name">Vehicular Access</span></div></>
                : Object.keys(data)[i] === "electricHookup"
                ? <><div className="img-text"><span className="img-tag"><img src={ElectricHookup2} alt='icons' className='table-icons'/></span><span className="pro-name">Electric Hookup</span></div></>
                : Object.keys(data)[i] === "waterhookup"
                ? <><div className="img-text"><span className="img-tag"><img src={WaterHookup2} alt='icons' className='table-icons'/></span><span className="pro-name">Water Hookup</span></div></>
                : Object.keys(data)[i] === "sewerhookup"
                ? <><div className="img-text"><span className="img-tag"><img src={SewerHookup2} alt='icons' className='table-icons'/></span><span className="pro-name">Sewer Hookup</span></div></>
                : Object.keys(data)[i] === "additionallodging"
                ? <><div className="img-text"><span className="img-tag"><img src={AdditionalLodging2} alt='icons' className='table-icons'/></span><span className="pro-name">Additional Lodging</span></div></>
                : Object.keys(data)[i] === "noofsites"
                ? <><div className="img-text"><span className="img-tag"><img src={NoofSpots} alt='icons' className='table-icons'/></span><span className="pro-name">No. of Spots</span></div></>
                :
                Object.keys(data)[i] === "Hiking"
                ? <><div className="img-text"><span className="img-tag"><img src={Hiking} alt='icons' className='table-icons' style={{height: '16px'}}/></span><span className="pro-name">Hiking</span></div></>
               : Object.keys(data)[i] === "Boating/Boat Rentals"
               ? <><div className="img-text"><span className="img-tag"><img src={BoatingRentals} alt='icons' className='table-icons' style={{height: '12px'}}/></span><span className="pro-name">Boating/Boat Rentals</span></div></>
               : Object.keys(data)[i] === "Kayaking"
               ? <><div className="img-text"><span className="img-tag"><img src={Kayaking} alt='icons' className='table-icons' style={{height: '16px'}}/></span><span className="pro-name">Kayaking</span></div></>
              : Object.keys(data)[i] === "Canoeing"
               ? <><div className="img-text"><span className="img-tag"><img src={Canoeing} alt='icons' className='table-icons' style={{height: '16px'}}/></span><span className="pro-name">Canoeing</span></div></>
               : Object.keys(data)[i] === "Others"
               ? <><div className="img-text"><span className="img-tag"><img src={Others} alt='icons' className='table-icons' style={{height: '16px'}}/></span><span className="pro-name">Others</span></div></>
               :Object.keys(data)[i] === "glamping"
               ? <><div className="img-text"><span className="img-tag"><img src={glamping} alt='icons' className='table-icons' style={{height: '16px'}}/></span><span className="pro-name">Glamping</span></div></>
               :Object.keys(data)[i] === "electriclevehiclecharging"
               ? <><div className="img-text"><span className="img-tag"><img src={evCharging} alt='icons' className='table-icons' style={{height: '16px'}}/></span><span className="pro-name">EV Charging</span></div></>
               : Object.keys(data)[i];
            Object.keys(data)[i] !== "profileid" &&
            Object.keys(data)[i] !== "facilitytypeid" &&
            Object.keys(data)[i] !== "ownershipId" &&
            Object.keys(data)[i] !== "stateId" &&
            Object.keys(data)[i] !== "countryId" &&
            Object.keys(data)[i] !== "rvprofileid" &&
            Object.keys(data)[i] !== "streetaddress1" &&
            Object.keys(data)[i] !== "streetaddress2" &&
            Object.keys(data)[i] !== "city" &&
            Object.keys(data)[i] !== "statecode" &&
            Object.keys(data)[i] !== "countryname" &&
            Object.keys(data)[i] !== "zipcode" &&
            Object.keys(data)[i] !== "id" &&
            Object.keys(data)[i] !== "ecfiftyamp" &&
                        Object.keys(data)[i] !== "ebthirtyamp" &&
                        Object.keys(data)[i] !== "eatwentyamp" 
              ? list.push(
                  <TableRow key={Object.keys}>
                    <TableCell>{tableHeader}</TableCell>
                    <TableCell>
                      {Object.keys(data)[i] === "website"  || Object.keys(data)[i] === "ownerwebsite" ? validateUrlElement(Object.values(data)[i])
                      : (
                        Object.keys(data)[i] === "landsize" ?  Object.values(data)[i] === null ? '-' : Object.values(data)[i]  +  " Acres" 
                        : Object.keys(data)[i] === "others" ?
                        Object.values(data)[i].join(", ")
                        : Object.keys(data)[i] === "seasonalityname" ?  formatSeasonalityText(Object.values(data)[i]) : Object.values(data)[i] 
                      )}
                    </TableCell>
                  </TableRow>
                )
              : Object.keys(data)[i] === "ecfiftyamp" ||
              Object.keys(data)[i] === "ebthirtyamp" ||
              Object.keys(data)[i] === "eatwentyamp" ?
              eList.push(
                <TableRow>
                  <TableCell><span className="pro-name ul-list-item">{Object.keys(data)[i] === "eatwentyamp" ? "20 Amp" : Object.keys(data)[i] === "ebthirtyamp" ? "30 Amp" : Object.keys(data)[i] === "ecfiftyamp" ? "50 Amp" : ""}</span></TableCell>
                  <TableCell>{Object.values(data)[i]}</TableCell>
                  </TableRow>
                )
              : "";
          }
        }
      }
    }
    return list;
    return eList;
  };

  const downloadProfile = () => {
    
    var timestamp = new Date().getDate() + "" + new Date().getMonth() + "" + new Date().getFullYear() + "" + new Date().getTime();
    var fileName = "RVParkIQ_RVParksProfileDetail_" + timestamp + ".pdf"
    var alertMsg = "Your download is being processed. The " +
      fileName + 
      " file will be downloaded automatically to your browser when ready."
      setSnackOpen({
        ...snack,
        snackOpen: true,
        snackMsg: alertMsg,
      });

      const payload = {
        "profileId": profileId,
        "latitude": cLat,
        "longitude": cLng,
        "fileName": fileName
      }
      apiCommonTriggerBlob("post",`${Config.API_URL}/rvParks/profile/download`, payload).then((res) => {
        if (res.status === 200) {
        const url = window.URL.createObjectURL(new Blob([res.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        // this.setState({ link })
        link.click();
        } else if (res.status === 401) {
          navigate("/");
        }
      })
      .catch((error) => {
        handlingCatchError(error, navigate);
      });
  };

    //snack bar open/close
    const snackHandleclose = (event, reason) => {
      if (reason === "clickaway") {
        return;
      }
      setSnackOpen({ ...snack, snackOpen: false, snackMsg: "" });
  };
  
  return (
    <div>
      <div>
        <Row>
          <Col md="12">
            <div>
              <div>

                { !props.loaderProfile ?   <div className={location.pathname == "/preview-market" || location.pathname === "/market-data" || location.pathname === "/" || localStorage.getItem('user') !== null && JSON.parse(localStorage.getItem('user')).usertype === 'Free' ? "market-title free-title" :  "market-title"}>
                  <h5>
                    {profileData && profileData !== undefined
                      ? profileData.profile && profileData.profile.profilename
                      : ""}
                    <span>
                      {profileData && profileData !== undefined
                        ? profileData.profile &&
                          profileData.profile.facilitytypes
                        : ""}
                    </span>
                  </h5>
                  <div style={{
                    opacity : props?.isDemoMarket ? 0.5:1
                  }} className="fav-pdf">
                  { location.pathname === "/preview-market" ||  location.pathname === "/market-data" || location.pathname === "/"  ? "" : isFavProfile !== null ? (
                      <StarIcon
                        style={{ color: "#f15d47", cursor : props?.isDemoMarket ? "default" :"pointer"}}
                        onClick={() => {
                          if(!props?.isDemoMarket){
                            handleDeleteFavorite();
                          }
                        }}
                      />
                    ) : (
                      <StarBorderIcon
                         style={{
                         cursor : props?.isDemoMarket ? "default" :"pointer"
                        }}
                        onClick={() => {
                          if(!props?.isDemoMarket){
                            favoriteCurrentProfile();
                          }
                        }}
                      />
                    ) }
                 { location.pathname == "/preview-market" ||  location.pathname === "/market-data" || location.pathname === "/"  || localStorage.getItem('user') !== null && JSON.parse(localStorage.getItem('user')).usertype === 'Free' ? ""  :  <DownloadOutlinedIcon onClick={() =>{
                  
                  if(!props?.isDemoMarket && !((profileData === undefined || list.length === 0) || props.loaderProfile)){
                    downloadProfile()
                  }
                 }}/>}
                    {/* <Link
                      to={`/rvparksprofile-pdf/${profileId}/${cLat}/${cLng}`}
                      state={profileData}
                      className="export-profile"
                    >
                      {" "}
                      <DownloadOutlinedIcon
                        onClick={() => setDownloadPDF(true)}
                      />
                    </Link> */}
                  </div>
                  <Clear
                    onClick={() => props.toggleProfile(false)}
                    className="close-icon"
                  />
                  <p className="address-section">
                    <FmdGoodOutlinedIcon />
                    {profileData &&
                    profileData !== undefined &&
                    profileData.profile &&
                    profileData.profile.streetaddress1
                      ? profileData.profile.streetaddress1 + ", "
                     : ""}
                    {profileData &&
                    profileData !== undefined &&
                    profileData.profile &&
                    profileData.profile.streetaddress2
                      ? profileData.profile.streetaddress2 + ", "
                      : ""}
                    {profileData &&
                    profileData !== undefined &&
                    profileData.profile &&
                    profileData.profile.city
                      ? profileData.profile.city + ", "
                      : ""}
                    {profileData &&
                    profileData !== undefined &&
                    profileData.profile &&
                    profileData.profile.statecode
                      ? profileData.profile.statecode + " "
                      : ""}
                    {profileData &&
                    profileData !== undefined &&
                    profileData.profile &&
                    profileData.profile.zipcode
                      ? profileData.profile.zipcode
                      : ""}
                  </p>
                </div> : "" }
              </div>

              <div className="accordion-step">
                <Accordion
                  expanded={expanded === "panel1"}
                  onChange={handleChange("panel1")}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                >
                  <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                    <Typography>Property Details</Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Typography>
                      {" "}
                      <Table>
                        <TableBody>
                          {profileData &&
                          profileData !== undefined &&
                          profileData.profile &&
                          expanded === "panel1" && !props.loaderProfile
                            ? storelistProp(profileData.profile, "profile")
                            : ""}
                          {(profileData === undefined || list.length === 0) || props.loaderProfile ? (
                            <tr>
                              <td style={{ textAlign: "center" }} className="store-no-data" >
                                {props.loaderProfile ? <div className="loader-wrap-text"> <div className="loading-text"></div> </div> :  "No Data Available"   }
                              </td>
                            </tr>
                          ) : null}
                        </TableBody>
                      </Table>
                    </Typography>
                  </AccordionDetails>
                </Accordion>
                {profileData &&
                profileData !== undefined &&
                profileData.amenities !== undefined ? (
                  <Accordion
                    expanded={expanded === "panel2"}
                    onChange={handleChange("panel2")}
                    aria-controls="panel2a-content"
                    id="panel2a-header"
                  >
                    <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                      <Typography>Amenities and Features</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Typography>
                        {" "}
                        <Table>
                          <TableBody>
                            {profileData &&
                            profileData !== undefined &&
                            profileData.amenities &&
                            expanded === "panel2"
                              ? storelistProp(
                                  sortObject(profileData.amenities),
                                  "amenities"
                                )
                              : ""}
                              {eList.length > 0 ?
                              <>
                                <TableRow colSpan={2}>
                                  <TableCell colSpan={2}><div className="img-text"><span className="img-tag"><img src={ElectricHookup2} alt='icons' className='table-icons'/></span><span className="pro-name">Electric Hookup</span></div></TableCell>
                                </TableRow>
                                {eList}
                                </>
                              : ''}
                            {profileData === undefined || list.length === 0 ? (
                              <tr>
                                <td
                                  style={{ textAlign: "center" }}
                                  className="store-no-data"
                                >
                                  No Data Available
                                </td>
                              </tr>
                            ) : (
                              ""
                            )}
                          </TableBody>
                        </Table>
                      </Typography>
                    </AccordionDetails>
                  </Accordion>
                ) : (
                  ""
                )}
{profileData &&
                profileData !== undefined &&
                profileData.profileactivity !== undefined ? (
                 <Accordion
                    expanded={expanded === "panel3"}
                    onChange={handleChange("panel3")}
                    aria-controls="panel3a-content"
                    id="panel3a-header"
                  >
                    <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                      <Typography>Activities/Attractions</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                    <Typography>
                        {" "}
                        <Table>
                          <TableBody>
                            {profileData &&
                            profileData !== undefined &&
                            profileData.profileactivity &&
                            expanded === "panel3"
                              ? storelistProp(
                                  sortActivity(profileData.profileactivity),
                                  "activity"
                                )
                              : ""}
                            {profileData === undefined || list.length === 0 ? (
                              <tr>
                                <td
                                  style={{ textAlign: "center" }}
                                  className="store-no-data"
                                >
                                  No Data Available
                                </td>
                              </tr>
                            ) : (
                              ""
                            )}
                          </TableBody>
                        </Table>
                      </Typography>
                    </AccordionDetails>
                  </Accordion>
                ) : (
                  ""
                )}
                {profileData &&
                profileData !== undefined &&
                profileData.rentaldetail !== undefined ? (
                  <Accordion
                    expanded={expanded === "panel4"}
                    onChange={handleChange("panel4")}
                    aria-controls="panel4a-content"
                    id="panel4a-header"
                  >
                    <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                      <Typography>Rate Details</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Typography>
                        {" "}
                        <Table>
                          <TableBody>
                            {profileData &&
                            profileData !== undefined &&
                            profileData.rentaldetail &&
                            expanded === "panel4"
                              ? storelistProp(
                                  profileData.rentaldetail,
                                  "rateDetails"
                                )
                              : ""}
                            {profileData === undefined || list.length === 0 ? (
                              <tr>
                                <td
                                  style={{ textAlign: "center" }}
                                  className="store-no-data"
                                >
                                  No Data Available
                                </td>
                              </tr>
                            ) : null}
                          </TableBody>
                        </Table>
                      </Typography>
                    </AccordionDetails>
                  </Accordion>
                ) : (
                  ""
                )}
                {/* <Accordion
                  expanded={expanded === "panel4"}
                  onChange={handleChange("panel4")}
                  aria-controls="panel4a-content"
                  id="panel4a-header"
                >
                  <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                    <Typography>Marketing</Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Typography>
                      {" "}
                      <Table>
                        <TableBody>
                          {profileData &&
                          profileData !== undefined &&
                          profileData.managementDetails &&
                          expanded === "panel4"
                            ? storelistProp(
                                profileData.managementDetails,
                                "marketing"
                              )
                            : ""}
                          {list.length === 0 ? (
                            <tr>
                              <td
                                style={{ textAlign: "center" }}
                                className="store-no-data"
                              >
                                No Data Available
                              </td>
                            </tr>
                          ) : (
                            ""
                          )}
                        </TableBody>
                      </Table>
                    </Typography>
                  </AccordionDetails>
                </Accordion> */}
                {profileData &&
                profileData !== undefined &&
                profileData.ownerdetails !== undefined ? (
                  <Accordion
                    expanded={expanded === "panel5"}
                    onChange={handleChange("panel5")}
                    aria-controls="panel5a-content"
                    id="panel5a-header"
                  >
                    <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                      <Typography>Ownership</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Typography>
                        {" "}
                        <Table>
                          <TableBody>
                            {profileData &&
                            profileData !== undefined &&
                            profileData.ownerdetails &&
                            expanded === "panel5"
                              ? storelistProp(
                                  profileData.ownerdetails,
                                  "ownership"
                                )
                              : ""}
                            {profileData === undefined || list.length === 0 ? (
                              <tr>
                                <td
                                  style={{ textAlign: "center" }}
                                  className="store-no-data"
                                >
                                  No Data Available
                                </td>
                              </tr>
                            ):(null)}
                          </TableBody>
                        </Table>
                      </Typography>
                    </AccordionDetails>
                  </Accordion>
                ) : (
                  ""
                )}
                {profileData &&
                profileData !== undefined &&
                profileData.loandetails !== undefined ? (
                  <Accordion
                    expanded={expanded === "panel6"}
                    onChange={handleChange("panel6")}
                    aria-controls="panel6a-content"
                    id="panel6a-header"
                  >
                    <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                      <Typography>Valuation and Debt</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Typography>
                        {" "}
                        <Table>
                          <TableBody>
                            {profileData &&
                            profileData !== undefined &&
                            profileData.loandetails &&
                            expanded === "panel6"
                              ? storelistProp(profileData.loandetails, "debt")
                              : ""}
                            {profileData === undefined || list.length === 0 ? (
                              <tr>
                                <td
                                  style={{ textAlign: "center" }}
                                  className="store-no-data"
                                >
                                  No Data Available
                                </td>
                              </tr>
                            ) : null}
                          </TableBody>
                        </Table>
                      </Typography>
                    </AccordionDetails>
                  </Accordion>
                ) : (
                  ""
                )}
                {downloadPDF ? <ExportProfile_Layout data={profileData} /> : ""}
              </div>

            <button
                className="use-market"
                onClick={() => {
                  if(props?.isDemoMarket){
                    props?.onExitDemoMarket();
                    return
                  }
                  props.callMarketCenter(cLat, cLng , true)}}
              >
                {props?.isDemoMarket ? "Exit Sample Market": "Use as market center"}
              </button>
            </div>
          </Col>
        </Row>
        <Snackbar
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
          open={snack.snackOpen}
          id="snack-success"
          className="snack-bar custom-snackbar"
          maxsnack={3}
          autoHideDuration={5000}
          onClose={snackHandleclose}
          ContentProps={{
            "aria-describedby": "message-id",
          }}
          message={<span id="message-id">{snack.snackMsg}</span>}
          action={[
            <Clear
              key="close"
              aria-label="Close"
              color="inherit"
              onClick={snackHandleclose}
            />,
          ]}
        />
      </div>
    </div>
  );
});

export default MarketProfile;
